import { useContext } from "react";

import { ProjectUser } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import {
  useInvalidateProjectUsersQuery,
  useUpdateProjectUsersQuery,
} from "@/queries/query-project-users";
import { ProjectContext } from "@/stores/project-provider";

export const removeProjectUsers = async (projectId: string, users: ProjectUser[]) => {
  await Promise.all(
    users.map(({ user }) =>
      getRanaApiV1().ProjectsApi.projectUserRoleDelete({ projectId, userId: user.id })
    )
  );
};

export const updateProjectUsersRole = async (
  projectId: string,
  users: ProjectUser[],
  role: ProjectUser["role"]
) => {
  return await Promise.all(
    users.map(({ user }) =>
      getRanaApiV1().ProjectsApi.projectUserRoleUpdate({
        projectId,
        userId: user.id,
        projectUserUpdate: { role },
      })
    )
  );
};

export const useUpdateProjectUsers = (users: ProjectUser[], onSuccess: () => void) => {
  const project = useContext(ProjectContext);
  const invalidateProjectUsersQuery = useInvalidateProjectUsersQuery();
  const updateProjectUsersQuery = useUpdateProjectUsersQuery();

  // Note: changing to a role of 'null' removes the user from the project
  return useMutationWithErrorHandler(
    async (role: ProjectUser["role"] | null) => {
      if (role === null) {
        await removeProjectUsers(project.id, users);
        invalidateProjectUsersQuery();
      } else {
        const updatedUsers = await updateProjectUsersRole(project.id, users, role);
        await Promise.all(updatedUsers.map((user) => updateProjectUsersQuery(user.user.id, user)));
      }
    },
    {
      onSuccess,
    }
  );
};
